const getters = {
	nickname(state, getters) {
		return state.nickname;
	},

	userId(state) {
		return state.userId;
	},

	credits(state) {
		return state.credits;
	},

	avatar(state) {
		return state.avatar;
	}
};

export default getters